/**
 * A Back/Forward visit restores its saved scroll position late: entry-client
 * waits up to 8 s (ROUTE_DESTINATION_READY_MAX_MS) for the visited page to
 * render before it applies the position. When a newer navigation starts in
 * that time, the late restore belongs to a page that is no longer on screen
 * and must not move the newer one. (D-2 of the catalog resilience delta
 * review, 2026-10-12: two quick Backs while page 3's answer was slow put
 * page 2 at page 3's saved position 8 s later.)
 *
 * entry-client supersedes the current visit on every popstate, in its early
 * listener that runs before vue-router's own (a query-only navigation can
 * complete in the microtasks right after vue-router's listener), and on every
 * router.push. A router.replace does not supersede: a page that rewrites its
 * own URL to the canonical form is still the same visit.
 */
export type RouteVisitTracker = {
  /** A newer Back/Forward or push started. */
  supersede: () => void;
  /**
   * The navigation that has just finished starts its visit. The returned
   * check stays true until the next supersede().
   */
  begin: () => () => boolean;
};

export const createRouteVisitTracker = (): RouteVisitTracker => {
  let generation = 0;
  return {
    supersede: () => {
      generation += 1;
    },
    begin: () => {
      const visit = generation;
      return () => visit === generation;
    },
  };
};
